import { useState } from 'react';
import { ApplicationIntro } from '~/modules/applications/components/ApplicationIntro/ApplicationIntro';
import { useParams } from 'react-router-dom';
import { useGetCourse } from '~/modules/applications/models/application.hooks';
import { CreateMentorApplicationForm } from '~/modules/applications/components/CreateMentorApplicationForm/CreateMentorApplicationForm';

const pages = {
  intro: 'intro',
  form: 'form',
};

export const CreateMentorApplication = () => {
  const { id } = useParams();
  const course = useGetCourse(id);
  const [page, setPage] = useState(pages.intro);

  const nextPageCallback = () => {
    setPage(pages.form);
  };

  const previousPageCallback = () => {
    setPage(pages.intro);
  };

  if (!course) {
    return null;
  }

  return (
    <div className="create-mentor-application">
      {page === pages.form && <CreateMentorApplicationForm previousPage={previousPageCallback} course={course} />}
      {page === pages.intro && (
        <ApplicationIntro
          title={'Mentor Application - ' + course.name}
          text={course.mentor_application_intro}
          description={course.description}
          nextPage={nextPageCallback}
        />
      )}
    </div>
  );
};
